<template>
    <div class="card">
        <header class="card-header">
            <h1>Logged Out</h1>
        </header>
        <div class="card-body">
            <router-link to="/">Log Back In</router-link>
        </div>
    </div>
</template>

<script>

export default {
     name: 'Logoff'  
}
</script>
